import React, { useRef, useState } from 'react'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { thousandSeparator } from '../../utils/helpers'

const TotalSalesListing = ({
  filterData,
  entities,
  handleClick
}) => {
  const inputRef = useRef(null)
  const divRef = useRef(null)
  const [showSearchBox, setShowSearchBox] = useState(false)
  const [filteredData, setFilteredData] = useState(entities || [])

  const handleShowSearchBox = () => {
    setShowSearchBox(!showSearchBox)
    if (setShowSearchBox) inputRef.current.focus()
  }

  const handleSearchData = (e) => {
    let searchQuery = e.target.value;
  
    const filteredData = entities.filter((row) => {
      return Object.values(row).some((value) => {
        if (typeof value === 'string' || typeof value === 'number') {
          if (typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase())) {
            return true;
          }
          if (typeof value === 'number' && value.toString().includes(searchQuery)) {
            return true;
          }
        }
        return false;
      });
    });
  
    setFilteredData(filteredData);
    divRef.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  };

  return (
    <>
      <div className='header'>
        <p className='title'>{ filterData.DateYear } Total Completed Sales Commission by { filterData.LiveListBy }</p>

        <div className='search-wrapper'>
          <div className='btn-search list'>
            <FontAwesomeIcon
              onClick={ handleShowSearchBox }
              icon={ faMagnifyingGlass }
              className={ 'icon ' + (showSearchBox ? 'text-primary' : '') }
            />

            <input
              ref={ inputRef }
              type='text'
              onInput={ handleSearchData }
              onBlur={ () => setShowSearchBox(false) }
              placeholder='Search for any keywords'
              className={ (showSearchBox ? 'searchbox-open' : 'w-0') }
            />
          </div>
        </div>
      </div>

      <div className='lists-wrapper md:h-auto h-[56px]'>
        <div ref={ divRef } className='scrollable'>
          <div className='lists'>
            {
              filteredData?.map((data, index) => (
                <div
                  key={ index }
                  onClick={ () => handleClick(data) }
                  className='list group'
                >
                  <p className='branch-name text-gray-two group-hover:text-primary'>{ data.BranchName }</p>

                  <p className='commission text-gray-one group-hover:text-primary'>
                    RM { data?.CommissionTotalSum ? thousandSeparator(data?.CommissionTotalSum) : 0 }
                  </p>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default TotalSalesListing